import { assetUrl } from '../http/build-url';
import { asHexColor, asString } from '../http/normalise';
import { ApiPublicTheme } from './theme.dto';
import { WorkspaceTheme } from './workspace-theme.model';

export function mapWorkspaceTheme(
  dto: ApiPublicTheme | undefined,
  storageBase: string
): WorkspaceTheme | null {
  if (dto === undefined) {
    return null;
  }

  return {
    displayName: asString(dto.displayName),
    logoUrl: assetUrl(storageBase, dto.logoUrl),
    faviconUrl: assetUrl(storageBase, dto.faviconUrl),
    primary: asHexColor(dto.primary),
    accent: asHexColor(dto.accent),
    sidebar: asHexColor(dto.sidebar),
  };
}
